import React from 'react';
import { Settings } from 'lucide-react';
import { C } from '../../styles/tokens';

/** "You're currently on [Plan] plan" card with the Billing button that opens BillingModal. */
export default function CurrentPlanCard({ planName, onOpenBilling, style }) {
  return (
    <div style={{
      background: C.w, border: `1px solid ${C.n200}`, borderRadius: 13, padding: '16px 18px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
      ...style,
    }}>
      <div>
        <div style={{ fontSize: 12.5, color: C.n500, marginBottom: 4 }}>You're currently on</div>
        <div style={{ fontSize: 16, fontWeight: 800, color: C.n900 }}>{planName} plan</div>
      </div>
      <button
        type="button"
        onClick={onOpenBilling}
        style={{
          display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px',
          background: C.w, border: `1px solid ${C.n300}`, borderRadius: 9,
          fontSize: 12.5, fontWeight: 700, color: C.n900, cursor: 'pointer', flexShrink: 0,
        }}
      >
        <Settings size={13} />
        Billing
      </button>
    </div>
  );
}
